import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useDebugAttributes } from '../hooks/use-debug-attributes.js';

function TabStripPrimitiveInner({ manager, ...props }, ref) {
    const fplData = useDebugAttributes({ container: 'tab-strip' });
    return (jsx("div", { "data-fpl-component": "primitive", ref: ref, ...fplData, ...props, role: "tablist", "aria-orientation": manager.orientation, "data-tab-group": manager.tabGroupId }));
}
TabStripPrimitiveInner.displayName = 'TabsPrimitive.TabStrip';
/**
 * TabsPrimitive.TabStrip is an unstyled (“headless”) component used to wrap Tab components.
 * Use `TabsPrimitive.TabStrip` only if you need custom styling; otherwise, use
 * `Tabs.TabStrip`. @see https://fpl.figma.design/components/tabs/
 */
const TabStripPrimitive = forwardRef(TabStripPrimitiveInner);

export { TabStripPrimitive };
//# sourceMappingURL=tab-strip-primitive.js.map
